function CompanyService($q, halClient, BBModel, $rootScope) {
    'ngInject';

    return {
        query(company_id, options) {
            if (!options['root']) {
                options['root'] = '';
            }
            const url = options['root'] + '/api/v1/company/' + company_id;
            const deferred = $q.defer();
            halClient.$get(url, options).then((company) => {
                    return deferred.resolve(company);
                }
                , (err) => {
                    return deferred.reject(err);
                }
            );
            return deferred.promise;
        },

        queryChildren(company) {
            const deferred = $q.defer();
            if (!company.$has('companies')) {
                deferred.reject('No child companies found');
            } else {
                company.$get('companies').then((resource) => {

                        return resource.$get('companies').then((items) => {
                                const companies = [];
                                for (const i of Array.from(items)) {
                                    companies.push(new BBModel.Company(i));
                                }
                                return deferred.resolve(companies);
                            }
                        );
                    }
                    , (err) => {
                        return deferred.reject(err);
                    }
                );
            }
            return deferred.promise;
        },

        queryByCoords(company_id, options) {
            options.root = options.root || $rootScope.bb.api_url;
            options.coords = options.coords || null;
            options.radius = options.radius || null;

            if (options.coords === null) {
                console.error('Make sure you passed the options.coords parameter');
                return false;
            }

            let url = options.root + '/api/v1/company/' + company_id + '/search?address[lat]=' + options.coords.lat + '&address[long]=' + options.coords.long;

            if (options.radius) {
                url += `&address[radius]=${options.radius}`;
            }
            if (options.page) {
                url += `&page=${options.page}`;
            }
            if (options.per_page) {
                url += `&per_page=${options.per_page}`;
            }

            if (options.service_id) {
                url += `&service_id=${options.service_id}`;
            }

            const deferred = $q.defer();
            halClient.$get(url, options).then((resource) => {
                    resource.$get('companies').then((items) => {
                        const companies = [];
                        for (const i of Array.from(items)) {
                            companies.push(new BBModel.Company(i));
                        }
                        return deferred.resolve(companies);
                    });
                }
                , (err) => {
                    return deferred.reject(err);
                }
            );

            return deferred.promise;
        },

        queryByText(company_id, options) {
            options.root = options.root || $rootScope.bb.api_url;
            options.text = options.text || null;

            if (options.text === null) {
                console.error('Make sure you passed the option.text parameter');
                return false;
            }



            let url = options.root + '/api/v1/company/' + company_id + '/search?company[text]=' + encodeURI(options.text);

            if (options.service_id) {
                url += `&service_id=${options.service_id}`;
            }
            
            const deferred = $q.defer();
            halClient.$get(url, options).then((resource) => {
                    resource.$get('companies').then((items) => {
                        const companies = [];
                        for (const i of Array.from(items)) {
                            companies.push(new BBModel.Company(i));
                        }
                        return deferred.resolve(companies);
                    });
                }
                , (err) => {
                    return deferred.reject(err);
                }
            );
            return deferred.promise;
        },

        queryByRef(reference, options) {

            const url = $rootScope.bb.api_url + '/api/v1/company/find_by_ref/' + reference;
            
            const deferred = $q.defer();
            
            halClient.$get(url, options).then((company) => {
                company = new BBModel.Company(company);
                deferred.resolve(company);
            }
            , (err) => {
                deferred.reject('Invalid Company Reference: ' + reference);
            });

            return deferred.promise;

        }

    };
}

angular
    .module('BB')
    .service('CompanyService', CompanyService);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/company.service.js